(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ts-brand-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-ts-bsc-ready')) return;
    root.setAttribute('data-ts-bsc-ready', '1');
    var tabsWrap = root.querySelector('[data-ts-bsc-tabs]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function applyFilter(panel, f) {
      if (!panel) return;
      var rows = panel.querySelectorAll('tbody tr');
      for (var i = 0; i < rows.length; i++) {
        var g = rows[i].getAttribute('data-group') || '';
        rows[i].hidden = !!f && g.indexOf(f) === -1;
      }
      var bar = panel.querySelector('[data-ts-bsc-filterbar]');
      if (bar) {
        bar.hidden = !f;
        var nm = bar.querySelector('[data-ts-bsc-filtername]');
        if (nm) nm.textContent = f;
      }
    }

    function activate(n, filter, focus) {
      if (!tabsWrap) return;
      var tabs = tabsWrap.querySelectorAll('[data-ts-bsc-tab]');
      var panels = tabsWrap.querySelectorAll('[data-ts-bsc-panel]');
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-ts-bsc-tab') === String(n);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
        tabs[i].classList.toggle('is-active', on);
        if (on && focus) tabs[i].focus();
      }
      for (var j = 0; j < panels.length; j++) {
        var show = panels[j].getAttribute('data-ts-bsc-panel') === String(n);
        panels[j].hidden = !show;
        if (show) applyFilter(panels[j], filter || '');
      }
    }

    if (tabsWrap) {
      tabsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-ts-bsc-tab]');
        if (t) { activate(t.getAttribute('data-ts-bsc-tab'), ''); return; }
        var c = e.target.closest('[data-ts-bsc-clear]');
        if (c) applyFilter(c.closest('[data-ts-bsc-panel]'), '');
      });
      tabsWrap.addEventListener('keydown', function (e) {
        var t = e.target.closest('[data-ts-bsc-tab]');
        if (!t) return;
        var tabs = tabsWrap.querySelectorAll('[data-ts-bsc-tab]');
        var idx = Array.prototype.indexOf.call(tabs, t);
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activate(next.getAttribute('data-ts-bsc-tab'), '', true); }
      });
    }

    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-ts-bsc-open]');
      if (!o || !tabsWrap) return;
      activate(o.getAttribute('data-ts-bsc-open'), o.getAttribute('data-ts-bsc-filter') || '');
      if (o.tagName === 'BUTTON') {
        var lib = root.querySelector('[data-ts-bsc-library]');
        if (lib) lib.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });

    var hdr = null;
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    for (var k = 0; k < groups.length; k++) {
      var pos = getComputedStyle(groups[k]).position;
      if (pos === 'sticky' || pos === 'fixed') { hdr = groups[k]; break; }
    }
    function setTop() {
      var h = hdr ? hdr.getBoundingClientRect().height : 0;
      root.style.setProperty('--ts-bsc-top', Math.round(h + 20) + 'px');
    }
    setTop();
    window.addEventListener('resize', setTop);

    var links = root.querySelectorAll('[data-ts-bsc-link]');
    if ('IntersectionObserver' in window && links.length) {
      var map = {};
      for (var m = 0; m < links.length; m++) {
        var id = (links[m].getAttribute('href') || '').slice(1);
        var el = id && document.getElementById(id);
        if (el) map[id] = links[m];
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          for (var q = 0; q < links.length; q++) links[q].classList.remove('is-current');
          var a = map[en.target.id];
          if (a) a.classList.add('is-current');
        });
      }, { rootMargin: '-35% 0px -60% 0px' });
      Object.keys(map).forEach(function (key) { io.observe(document.getElementById(key)); });
      links[0].classList.add('is-current');
    }
  }

  var roots = document.querySelectorAll('[data-ts-bsc]');
  for (var r = 0; r < roots.length; r++) init(roots[r]);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[data-ts-bsc]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-page-style"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.tsFiltersReady) return;
  window.tsFiltersReady = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ts-more]');
    if (!button) return;
    event.preventDefault();
    var list = button.previousElementSibling;
    if (!list) return;
    var expanded = list.classList.toggle('is-expanded');
    button.textContent = expanded ? button.getAttribute('data-less') : button.getAttribute('data-more');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var collapsible = button.closest('.collection__filter-collapsible');
    if (collapsible && collapsible.getAttribute('aria-hidden') === 'false') collapsible.style.height = 'auto';
  });
  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-ts-filter-search]');
    if (!input) return;
    var query = input.value.trim().toLowerCase();
    var list = input.nextElementSibling;
    if (!list) return;
    list.classList.toggle('is-searching', query !== '');
    Array.prototype.forEach.call(list.children, function (item) {
      item.hidden = query !== '' && item.textContent.toLowerCase().indexOf(query) === -1;
    });
    var more = list.nextElementSibling;
    if (more && more.hasAttribute('data-ts-more')) more.hidden = query !== '';
    var collapsible = input.closest('.collection__filter-collapsible');
    if (collapsible && collapsible.getAttribute('aria-hidden') === 'false') collapsible.style.height = 'auto';
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.closest && event.target.closest('[data-ts-filter-search]')) event.preventDefault();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-quick-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.tsQuickOrderInit) return;
  window.tsQuickOrderInit = true;

  var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
  var searchUrl = (window.routes && window.routes.searchUrl) || '/search';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function norm(s) { return String(s || '').trim().toUpperCase(); }

  // "SKU, 4" / "SKU 4" / "SKU<tab>4" / "4 x SKU" / "SKU" (quantity 1). A "SKU,Quantity" header row is skipped.
  function parse(text, max) {
    var map = {};
    var order = [];
    var skipped = 0;
    text.split(/\r?\n/).forEach(function (line) {
      var parts = line.replace(/"/g, '').trim().split(/[,;\t]+|\s+/).filter(Boolean);
      if (!parts.length) return;
      var sku = parts[0];
      var qty = 1;
      if (parts.length > 1 && /^\d+$/.test(parts[0]) && !/^\d+$/.test(parts[parts.length - 1])) {
        qty = parseInt(parts[0], 10);
        sku = parts[parts.length - 1];
      } else if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) {
        qty = parseInt(parts[parts.length - 1], 10);
      }
      if (/^x$/i.test(sku)) return;
      if (/^sku$/i.test(sku)) return;
      var key = norm(sku);
      if (!map[key]) {
        if (order.length >= max) { skipped++; return; }
        map[key] = { sku: sku, qty: 0 };
        order.push(key);
      }
      map[key].qty += isNaN(qty) ? 1 : qty;
    });
    return { lines: order.map(function (k) { return map[k]; }), skipped: skipped };
  }

  function lookup(term) {
    var url = searchUrl + '?type=product&view=ts-sku&q=' + encodeURIComponent(term);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { try { return JSON.parse(t).results || []; } catch (e) { return []; } })
      .catch(function () { return []; });
  }

  function dist(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) { d[i] = [i]; }
    for (j = 0; j <= n; j++) { d[0][j] = j; }
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
    }
    return d[m][n];
  }

  function suggest(sku, pool) {
    var key = norm(sku);
    var seen = {};
    return pool
      .filter(function (v) { var s = norm(v.sku); if (!s || seen[s]) return false; seen[s] = true; return true; })
      .map(function (v) { return { sku: v.sku, d: dist(key, norm(v.sku)) }; })
      .filter(function (x) { return x.d <= Math.max(2, Math.floor(key.length / 3)); })
      .sort(function (a, b) { return a.d - b.d; })
      .slice(0, 2)
      .map(function (x) { return x.sku; });
  }

  // Find one SKU: exact (case-insensitive) match on a variant SKU. If none, search again with the SKU's
  // stem (text before the last dash or trailing size code) to offer close SKUs.
  function resolve(line) {
    var key = norm(line.sku);
    return lookup(line.sku).then(function (res) {
      var hit = res.filter(function (v) { return norm(v.sku) === key; })[0];
      if (hit) return { line: line, hit: hit, sugg: [] };
      var stem = line.sku.replace(/[-_ .][^-_ .]*$/, '');
      if (stem.length < 3 || stem === line.sku) stem = line.sku.slice(0, Math.max(3, line.sku.length - 2));
      return lookup(stem).then(function (res2) {
        var hit2 = res2.filter(function (v) { return norm(v.sku) === key; })[0];
        if (hit2) return { line: line, hit: hit2, sugg: [] };
        return { line: line, hit: null, sugg: suggest(line.sku, res.concat(res2)) };
      });
    });
  }

  function limit(items, n, fn) {
    var out = new Array(items.length), i = 0;
    function next() {
      if (i >= items.length) return Promise.resolve();
      var k = i++;
      return fn(items[k]).then(function (r) { out[k] = r; return next(); });
    }
    var workers = [];
    for (var w = 0; w < Math.min(n, items.length); w++) workers.push(next());
    return Promise.all(workers).then(function () { return out; });
  }

  function Pad(root) {
    this.root = root;
    this.max = parseInt(root.getAttribute('data-max-lines'), 10) || 100;
    this.input = root.querySelector('[data-tsq-input]');
    this.review = root.querySelector('[data-tsq-review]');
    this.rows = [];
    this.bind();
  }

  Pad.prototype.bind = function () {
    var self = this;
    var root = this.root;
    root.querySelector('[data-tsq-check]').addEventListener('click', function () { self.check(); });
    var file = root.querySelector('[data-tsq-file]');
    var drop = root.querySelector('[data-tsq-drop]');
    file.addEventListener('change', function () { if (file.files[0]) self.readFile(file.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) self.readFile(f);
    });
    this.review.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      var i = parseInt(t.getAttribute('data-i'), 10);
      if (t.hasAttribute('data-tsq-rm')) { self.rows.splice(i, 1); self.render(); }
      else if (t.hasAttribute('data-tsq-sug')) { self.retry(i, t.getAttribute('data-sku')); }
      else if (t.hasAttribute('data-tsq-edit')) { self.input.focus(); self.input.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else if (t.hasAttribute('data-tsq-add')) { self.add(t); }
    });
    this.review.addEventListener('change', function (e) {
      var q = e.target.closest('[data-tsq-qty]');
      if (!q) return;
      var row = self.rows[parseInt(q.getAttribute('data-i'), 10)];
      var v = Math.max(0, parseInt(q.value, 10) || 0);
      row.qty = row.max != null ? Math.min(v, row.max) : v;
      row.changed = row.max != null && v > row.max;
      self.render();
    });
  };

  Pad.prototype.readFile = function (f) {
    var self = this;
    var reader = new FileReader();
    reader.onload = function () {
      self.input.value = String(reader.result || '').trim();
      var name = self.root.querySelector('[data-tsq-filename]');
      if (name) name.textContent = f.name;
      self.check();
    };
    reader.readAsText(f);
  };

  Pad.prototype.check = function () {
    var self = this;
    var parsed = parse(this.input.value, this.max);
    if (!parsed.lines.length) {
      this.review.innerHTML = '<p class="tsq__msg tsq__msg--x" style="border-top:0">Paste at least one SKU, or upload a CSV file.</p>';
      return;
    }
    this.skipped = parsed.skipped;
    this.review.innerHTML = '<div class="tsq__loading">Checking ' + parsed.lines.length + (parsed.lines.length === 1 ? ' SKU' : ' SKUs') + '...</div>';
    Promise.all([
      fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }),
      limit(parsed.lines, 4, resolve)
    ]).then(function (all) {
      var inCart = {};
      (all[0].items || []).forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      self.inCart = inCart;
      self.rows = all[1].map(function (r) { return self.makeRow(r); });
      self.render();
    });
  };

  Pad.prototype.makeRow = function (r) {
    var row = { sku: r.line.sku, want: r.line.qty, qty: r.line.qty, hit: r.hit, sugg: r.sugg, max: null, changed: false, note: '' };
    if (!r.hit) { row.state = 'x'; row.qty = 0; return row; }
    var v = r.hit;
    var limited = v.tracked === 'shopify' && v.policy === 'deny';
    var already = (this.inCart && this.inCart[v.id]) || 0;
    if (!v.available) { row.state = 'x'; row.qty = 0; row.note = 'Sold out'; return row; }
    if (limited) {
      row.max = Math.max(0, v.qty - already);
      if (row.max === 0) { row.state = 'x'; row.qty = 0; row.note = already ? 'No more in stock (you already have ' + already + ' in your cart)' : 'Sold out'; return row; }
      if (row.want > row.max) {
        row.qty = row.max;
        row.changed = true;
        row.note = 'Only ' + row.max + ' available' + (already ? ' (you already have ' + already + ' in your cart)' : ' in stock') + ', quantity set to ' + row.max;
      }
    }
    row.state = row.changed ? 'w' : 'ok';
    return row;
  };

  Pad.prototype.retry = function (i, sku) {
    var self = this;
    var old = this.rows[i];
    resolve({ sku: sku, qty: old.want }).then(function (r) {
      self.rows[i] = self.makeRow(r);
      self.render();
    });
  };

  Pad.prototype.render = function (msg) {
    var rows = this.rows;
    if (!rows.length) {
      this.review.innerHTML = '<div class="tsq__empty"><p>Your list is empty. Paste SKUs on the left and click Check my list.</p></div>';
      return;
    }
    var ready = 0, changed = 0, missing = 0, items = 0, total = 0, lines = 0;
    var html = rows.map(function (r, i) {
      var rm = '<button type="button" class="tsq__rm" data-tsq-rm data-i="' + i + '" aria-label="Remove ' + esc(r.sku) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
      if (r.state === 'x') {
        missing++;
        var note;
        if (r.hit) {
          note = '<div class="tsq__meta tsq__meta--x">' + esc(r.note) + '</div>';
          return '<div class="tsq__row"><span class="tsq__st tsq__st--x">&times;</span><div class="tsq__ph">' + (r.hit.image ? '<img src="' + esc(r.hit.image) + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="tsq__info"><a class="tsq__t" href="' + esc(r.hit.url) + '">' + esc(r.hit.title) + '</a><div class="tsq__meta">SKU ' + esc(r.hit.sku) + '</div>' + note + '</div>' +
            '<div class="tsq__lt tsq__lt--x"><s>Qty ' + r.want + '</s>Skipped</div>' + rm + '</div>';
        }
        var sug = r.sugg.length ? ' Did you mean ' + r.sugg.map(function (s) { return '<button type="button" class="tsq__sug" data-tsq-sug data-i="' + i + '" data-sku="' + esc(s) + '">' + esc(s) + '</button>'; }).join(' or ') + '?' : ' Check the SKU and try again.';
        return '<div class="tsq__row"><span class="tsq__st tsq__st--x">&times;</span><div class="tsq__ph"></div>' +
          '<div class="tsq__info"><span class="tsq__sku">' + esc(r.sku) + '</span><div class="tsq__meta tsq__meta--x">No product with this SKU.' + sug + '</div></div>' +
          '<div class="tsq__lt tsq__lt--x"><s>Qty ' + r.want + '</s>Skipped</div>' + rm + '</div>';
      }
      var v = r.hit;
      if (r.qty > 0) { lines++; items += r.qty; total += v.price * r.qty; }
      if (r.changed) changed++; else ready++;
      var title = esc(v.title) + (v.single ? '' : ' <span style="font-weight:600;color:#6a6a70">(' + esc(v.variant) + ')</span>');
      var meta = r.changed ? '<div class="tsq__meta tsq__meta--w">' + esc(r.note) + '</div>' : '<div class="tsq__meta">SKU ' + esc(v.sku) + ' &middot; ' + money(v.price) + ' each</div>';
      return '<div class="tsq__row"><span class="tsq__st' + (r.changed ? ' tsq__st--w' : '') + '">' + (r.changed ? '!' : '&#10003;') + '</span>' +
        '<div class="tsq__ph">' + (v.image ? '<img src="' + esc(v.image) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="tsq__info"><a class="tsq__t" href="' + esc(v.url) + '">' + title + '</a>' + meta + '</div>' +
        '<input type="number" min="0"' + (r.max != null ? ' max="' + r.max + '"' : '') + ' inputmode="numeric" class="tsq__qty" data-tsq-qty data-i="' + i + '" value="' + r.qty + '" aria-label="Quantity for ' + esc(v.sku) + '">' +
        '<div class="tsq__lt">' + (r.changed ? '<s>Qty ' + r.want + '</s>' : '') + money(v.price * r.qty) + '</div>' + rm + '</div>';
    }).join('');

    var chips = '<div class="tsq__counts">' +
      (ready ? '<span class="tsq__chip">' + ready + ' ready</span>' : '') +
      (changed ? '<span class="tsq__chip tsq__chip--w">' + changed + ' changed</span>' : '') +
      (missing ? '<span class="tsq__chip tsq__chip--x">' + missing + ' not found or sold out</span>' : '') +
      (this.skipped ? '<span class="tsq__chip tsq__chip--x">' + this.skipped + ' over the ' + this.max + '-line limit</span>' : '') + '</div>';

    var label = items ? 'Add ' + items + (items === 1 ? ' item' : ' items') + ' to cart' : 'Nothing to add';
    var bar = '<div class="tsq__bar"><div class="tsq__total"><small>' + items + (items === 1 ? ' item' : ' items') + ' from ' + lines + (lines === 1 ? ' line' : ' lines') + '</small><b>' + money(total) + '</b></div>' +
      '<div class="tsq__acts"><button type="button" class="tsq__btn tsq__btn--ghost" data-tsq-edit>Edit list</button>' +
      '<button type="button" class="tsq__btn" data-tsq-add' + (items ? '' : ' disabled') + '>' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>' + label + '</button></div></div>';

    this.review.innerHTML = chips + '<div class="tsq__rows">' + html + '</div>' + bar + (msg || '');
  };

  Pad.prototype.add = function (btn) {
    var self = this;
    var items = this.rows.filter(function (r) { return r.hit && r.state !== 'x' && r.qty > 0; })
      .map(function (r) { return { id: r.hit.id, quantity: r.qty }; });
    if (!items.length) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var total = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    function post(list) {
      return fetch(cartUrl + '/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: list })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }
    post(items).then(function (res) {
      if (res.ok) return { added: total, failed: [] };
      // One line failed (usually stock changed): add the lines one at a time and report the ones that fail.
      var added = 0, failed = [];
      return items.reduce(function (p, it) {
        return p.then(function () {
          return post([it]).then(function (r) {
            if (r.ok) added += it.quantity;
            else failed.push({ id: it.id, msg: (r.body && (r.body.description || r.body.message)) || 'Could not be added' });
          });
        });
      }, Promise.resolve()).then(function () { return { added: added, failed: failed }; });
    }).then(function (out) {
      var msg;
      if (out.added) {
        msg = '<p class="tsq__msg tsq__msg--ok">Added ' + out.added + (out.added === 1 ? ' item' : ' items') + ' to your cart.</p>';
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: null, quantity: out.added, productAdded: true } }));
      }
      if (out.failed.length) {
        msg = (msg || '') + '<p class="tsq__msg tsq__msg--x">' + out.failed.length + (out.failed.length === 1 ? ' line' : ' lines') + ' could not be added: ' + out.failed.map(function (f) {
          var r = self.rows.filter(function (x) { return x.hit && x.hit.id === f.id; })[0];
          return esc((r ? r.hit.sku + ': ' : '') + f.msg);
        }).join('; ') + '</p>';
      }
      self.render(msg);
    }).catch(function () {
      self.render('<p class="tsq__msg tsq__msg--x">Something went wrong adding to the cart. Please try again.</p>');
    });
  };

  function init() {
    document.querySelectorAll('[data-ts-quick-order]').forEach(function (el) {
      if (!el.__tsq) el.__tsq = new Pad(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-tire-dimensions"] && !Shopify.designMode) return;
  try {
    
(function () {
  function show(root, id) {
    var blocks = root.querySelectorAll('[data-ts-dims-variant]');
    if (!blocks.length) return;
    var found = false;
    blocks.forEach(function (block) {
      var match = block.getAttribute('data-ts-dims-variant') === String(id);
      block.hidden = !match;
      if (match) found = true;
    });
    var empty = root.querySelector('[data-ts-dims-empty]');
    if (empty) empty.hidden = found || !!root.querySelector('[data-ts-dims-wheel], [data-ts-dims-hub]');
  }
  function update(id) {
    if (!id) return;
    document.querySelectorAll('[data-ts-dims]').forEach(function (root) { show(root, id); });
  }
  function init() {
    document.querySelectorAll('[data-ts-dims]').forEach(function (root) {
      var visible = root.querySelector('[data-ts-dims-variant]:not([hidden]), [data-ts-dims-wheel], [data-ts-dims-hub]');
      var empty = root.querySelector('[data-ts-dims-empty]');
      if (empty) empty.hidden = !!visible;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant) update(variant.id);
  });
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.name === 'id' && target.form && /\/cart\/add/.test(target.form.getAttribute('action') || '')) update(target.value);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-tire-specs"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Product-level table on products with options: one weight row for the selected option. The row is added or
     removed (shown before adding, hidden before removing) so the Specifications tab badge, which counts tbody rows
     and re-counts when a hidden attribute changes, always matches what shows. */
  function weight(root, id) {
    root.querySelectorAll('tbody[data-ts-weights]').forEach(function (body) {
      var map = {};
      body.getAttribute('data-ts-weights').split(';').forEach(function (pair) {
        var i = pair.indexOf(':');
        if (i > 0) map[pair.slice(0, i)] = pair.slice(i + 1);
      });
      var w = map[String(id)];
      var row = body.querySelector('[data-ts-weight]');
      if (w) {
        if (!row) {
          row = document.createElement('tr');
          row.setAttribute('data-ts-weight', '');
          row.hidden = true;
          var th = document.createElement('th');
          th.scope = 'row';
          th.textContent = body.getAttribute('data-ts-weight-label') || 'Shipping weight';
          row.appendChild(th);
          row.appendChild(document.createElement('td'));
          body.appendChild(row);
        }
        row.lastElementChild.textContent = w;
        row.hidden = false;
      } else if (row) {
        row.hidden = true;
        row.parentNode.removeChild(row);
      }
    });
  }

  function show(root, id) {
    weight(root, id);
    var blocks = root.querySelectorAll('[data-ts-specs-variant]');
    if (!blocks.length) return;
    var found = false;
    blocks.forEach(function (block) {
      var match = block.getAttribute('data-ts-specs-variant') === String(id);
      block.hidden = !match;
      if (match) found = true;
    });
    var empty = root.querySelector('[data-ts-specs-empty]');
    if (empty) empty.hidden = found || !!root.querySelector('[data-ts-specs-product]');
  }

  function update(id) {
    if (!id) return;
    document.querySelectorAll('[data-ts-specs]').forEach(function (root) { show(root, id); });
  }

  function init() {
    document.querySelectorAll('[data-ts-specs]').forEach(function (root) {
      var visible = root.querySelector('[data-ts-specs-variant]:not([hidden]), [data-ts-specs-product]');
      var empty = root.querySelector('[data-ts-specs-empty]');
      if (empty) empty.hidden = !!visible;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant) update(variant.id);
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.name === 'id' && target.form && /\/cart\/add/.test(target.form.getAttribute('action') || '')) {
      update(target.value);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
